import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8fd9f34c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-generator" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "lef" }
const _hoisted_4 = ["onMouseenter"]
const _hoisted_5 = {
  key: 1,
  class: "custom"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  style: {"flex":"1"}
}, "行数：", -1))
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  style: {"flex":"1"}
}, "列数：", -1))
const _hoisted_10 = { class: "btns" }

import { ref } from 'vue'
import {
  InputNumber,
  Button,
  message,
} from 'ant-design-vue'

interface InsertData {
  row: number
  col: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TableGenerator',
  emits: ["insert", "close"],
  setup(__props, { emit }: { emit: ({
  (event: 'insert', payload: InsertData): void
  (event: 'close'): void
}), expose: any, slots: any, attrs: any }) {



const endCell = ref<number[]>([])
const customRow = ref(3)
const customCol = ref(3)
const isCustom = ref(false)

const handleClickTable = () => {
  if (!endCell.value.length) return
  const [row, col] = endCell.value
  emit('insert', { row, col })
}

const insertCustomTable = () => {
  if (customRow.value < 1 || customRow.value > 20) return message.warning('行数/列数必须在0~20之间！')
  if (customCol.value < 1 || customCol.value > 20) return message.warning('行数/列数必须在0~20之间！')
  emit('insert', { row: customRow.value, col: customCol.value })
  isCustom.value = false
}

const close = () => {
  emit('close')
  isCustom.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, "表格 " + _toDisplayString(endCell.value.length ? `${endCell.value[0]} x ${endCell.value[1]}` : ''), 1),
      _createElementVNode("div", {
        class: "right",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isCustom.value = !isCustom.value))
      }, _toDisplayString(isCustom.value ? '返回' : '自定义'), 1)
    ]),
    (!isCustom.value)
      ? (_openBlock(), _createElementBlock("table", {
          key: 0,
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (endCell.value = [])),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (handleClickTable()))
        }, [
          _createElementVNode("tbody", null, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (row) => {
              return _createElementVNode("tr", { key: row }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (col) => {
                  return _createElementVNode("td", {
                    onMouseenter: ($event: any) => (endCell.value = [row, col]),
                    key: col
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["cell", { 'active': endCell.value.length && row <= endCell.value[0] && col <= endCell.value[1] }])
                    }, null, 2)
                  ], 40, _hoisted_4)
                }), 64))
              ])
            }), 64))
          ])
        ], 32))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_unref(InputNumber), {
              min: 1,
              max: 20,
              value: customRow.value,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((customRow).value = $event)),
              style: {"flex":"3"}
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_unref(InputNumber), {
              min: 1,
              max: 20,
              value: customCol.value,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((customCol).value = $event)),
              style: {"flex":"3"}
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_unref(Button), {
              class: "btn",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (close()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            _createVNode(_unref(Button), {
              class: "btn",
              type: "primary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (insertCustomTable()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("确认")
              ]),
              _: 1
            })
          ])
        ]))
  ]))
}
}

})